import { gql } from '@apollo/client';

export const UPDATE_STORAGE_METERING_RATE = gql`
  mutation UpdateStorageMeteringRate(
    $shipmentRate: Float!
    $query: UpdateStorageMeteringInput!
  ) {
    updateStorageMeteringRate(shipmentRate: $shipmentRate, query: $query) {
      shipmentId
      shipperId
    }
  }
`;

export const UPDATE_STORAGE_METERING_FREE_DAYS = gql`
  mutation UpdateStorageMeteringFreeDays(
    $freeDays: Float!
    $query: UpdateStorageMeteringInput!
  ) {
    updateStorageMeteringFreeDays(freeDays: $freeDays, query: $query) {
      shipmentId
      shipperId
    }
  }
`;
